import { IGenericObject } from "shared/programs/migration-acceleration-program/2024/fund-request/types/CommonTypes";
import {
  ARR_THRESHOLD_MULTIPLIER,
  MAP_LITE_THRESHOLD,
} from "shared/programs/migration-acceleration-program/2024/fund-request/utils/constants";
import { MAP2024_MIGRATION_PHASE } from "external/programs/migration-acceleration-program/2024/fund-request/components/create/eligibility/util";

import { removeCurrencyFormatting } from "shared/programs/migration-acceleration-program/2024/fund-request/util/currency";
import {
  MAP_MOBILIZE_FIRST_CLAIM_REALIZED_REVENUE_USD_AMOUNT
} from "../../../../../../external/components/FundRequest/ProgramSelectMAP2024/util";

export const isMobilizeMapLarge = (data: IGenericObject) => {
  return (
    data &&
    isMobilizePhase(data["migrationPhase"]) &&
    isMapLarge(data["arrUsdAmount"])
  );
};

export const isMapLarge = (arrUsdAmount?: string) => {
  return (
    arrUsdAmount &&
    parseInt(removeCurrencyFormatting(arrUsdAmount)) >= MAP_LITE_THRESHOLD
  );
};

export const isMobilizePhase = (migrationPhase?: string) => {
  return migrationPhase && migrationPhase === MAP2024_MIGRATION_PHASE.MOBILIZE;
};

export const isAssessPhase = (migrationPhase?: string) => {
  return migrationPhase && migrationPhase === MAP2024_MIGRATION_PHASE.ASSESS;
};

export const isWwps = (data: IGenericObject) => {
  if (data?.customerType === "PS") {
    return true;
  }
  if (data?.customerBizUnit === "PS") {
    return true;
  }
  return false;
};

// Check if migration tracking fields (ramp indicator, health indicator, agreement ID) have valid values
export const hasValidMigrationTrackingFields = (data?: IGenericObject): boolean =>
  !!(data &&
    [
      data["migrationRampIndicator"],
      data["migrationHealthIndicator"],
      data["agreementId"]
    ].some(value => value && value !== "-"));

// Check if a claim is not a BONUS claim
export const isNotVmwareClaim = (claim: IGenericObject) => {
  console.log("isNotVmwareClaim", !claim?.vmwareClaim);
  return !claim?.vmwareClaim;
}

// Calculate target spend based on claim priority
export const calculateTargetSpend = (claim: IGenericObject, data: IGenericObject): number => {
  console.log("claim", claim);
  const claimNumber = (claim?.claimPriority ?? -1) + 1;
  console.log("claimNumber", claimNumber);
  const arrUsdAmount = parseFloat(removeCurrencyFormatting(data.arrUsdAmount)) || 0;
  console.log("arrUsdAmount", arrUsdAmount);

  if (claimNumber === 1) {
    return MAP_MOBILIZE_FIRST_CLAIM_REALIZED_REVENUE_USD_AMOUNT;
  }
  if (claimNumber === 2) {
    return Math.round((arrUsdAmount || 0) * ARR_THRESHOLD_MULTIPLIER);
  }
  return 0;
};
